module.exports = __webpack_public_path__ + "img/ical.12b0dceb.png";